import { useTranslation } from 'react-i18next';
import useFetchThirdPartyAgencies from 'components/domain/agency/useFetchThirdPartyAgencies';
import SelectField from 'components/forms/selectField/SelectField';
import FieldPlaceholder from 'pages/property/common/FieldPlaceholder';
import TooltipContentWithLearnMore from 'pages/property/common/tooltip/TooltipContentWithLearnMore';
import { orderBy } from 'utils/arrayUtils';
import { getBestProfile } from 'utils/user/userUtils';

const PropertyVrboSettingsListedByField = () => {
  const { t } = useTranslation();

  const { data, isLoading } = useFetchThirdPartyAgencies();

  if (isLoading) {
    return (
      <FieldPlaceholder
        label={t('pageProperty.mainSettings.vrboSettings.agentUid')}
        name="vrboSettings.agentUid"
        colSmInput={7}
        colSmLabel={5}
        required
      />
    );
  }

  const agencyOptions = (data?.agents ?? []).map((agency) => ({
    value: agency.uid,
    label: getBestProfile(agency),
  }));

  const options = [
    {
      value: '',
      label: t('pageProperty.mainSettings.vrboSettings.selectThirdPartyAgency'),
    },
    ...orderBy(agencyOptions, [{ field: 'label', order: 'asc' }]),
  ];

  return (
    <SelectField
      label={t('pageProperty.mainSettings.vrboSettings.agentUid')}
      name="vrboSettings.agentUid"
      options={options}
      colSmInput={7}
      colSmLabel={5}
      rightTooltip={
        <TooltipContentWithLearnMore
          labelTooltipText={t(
            'pageProperty.mainSettings.vrboSettings.agentUidTooltip',
          )}
          learnMoreUrl="https://help.hostfully.com/en/articles/4352823-set-up-third-party-agency"
        />
      }
    />
  );
};

export default PropertyVrboSettingsListedByField;
